import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_DOCUMENTS_DOMAIN, IS_MOBILE_BROWSER } from 'reactApp/appHelpers/configHelpers';

export const disableRestMobileAllDocsFeatures: boolean = isFeature('disable-rest-mobile-all-docs-features') || true;

/** Убрать его, когда эпик мобильных доков PDSM-4749 будет закрыт */
export const hideAllDocsMobileFeatures = disableRestMobileAllDocsFeatures && IS_DOCUMENTS_DOMAIN && IS_MOBILE_BROWSER;
/** tempexp_19482-end */
